module.exports = __webpack_public_path__ + "img/Taiwan.d6433a47.svg";